<template>
	<div v-if="show" class="alert-container">
		<div class="info icon-container">
			<svgicon name="info" class="icon info" :original="true"></svgicon>
		</div>
		<div class="alert-message">
			<div class="errors">
				<span class="alert-info">{{ $t('serverErrorMessages') }}</span>
				<ul>
					<li v-for="(errorMessage, i) in errorMessages" :key="i">
						{{ errorMessage }}
					</li>
				</ul>
			</div>
		</div>
		<div class="buttons-container">
			<svgicon
				class="icon alert-refresh"
				name="alert-refresh"
				:original="true"
				@click="refresh"
			></svgicon>
			<svgicon
				class="icon alert-close"
				name="alert-close"
				:original="true"
				@click="close"
			></svgicon>
		</div>
	</div>
</template>
<script>
import '../icons/info';
import '../icons/alert-refresh';
import '../icons/alert-close';

export default {
	computed: {
		errorMessages() {
			return this.$store.getters.errorMessages;
		},
		show() {
			return this.errorMessages.length;
		}
	},
	methods: {
		close() {
			this.$store.commit('setErrorMessages', []);
		},
		refresh() {
			this.$router.go();
		}
	}
};
</script>
<style lang="scss" scoped>
.alert-container {
	display: flex;
	position: absolute;
	justify-content: flex-start;
	margin-top: 20px;
	margin-left: auto;
	margin-right: auto;
	padding: 8px 1%;
	top: 0;
	left: 0;
	right: 0;
	min-width: 32px;
	width: fit-content;
	max-width: 50%;
	min-height: 60px;
	background-color: $alert-container-bgcolor;
	border: 1px solid $alert-container-border-color;
	border-radius: 4px;
	z-index: 99;
	overflow: hidden;

	.icon {
		width: 24px;
		height: 24px;
		@media (min-width: $breakpoint-mid) {
			width: 32px;
			height: 32px;
		}
	}

	.info {
		padding-right: 3px;
		padding-bottom: 3px;
		flex-shrink: 0;
		margin-right: 8px;
	}

	.alert-message {
		font-family: 'RobotoMedium';
		font-size: 14px;
		letter-spacing: 0.5px;
		padding-top: 5px;
		color: $font-red-alert;

		.alert-info {
			font-size: 15px;
			@media (min-width: $breakpoint-mid) {
				font-size: 18px;
			}
		}

		ul {
			list-style-position: inside;
			padding-left: 0;

			li {
				word-wrap: break-word;
			}
		}

		@media (min-width: $breakpoint-mid) {
			font-size: 16px;
		}
	}

	.buttons-container {
		float: right;
		min-width: fit-content;

		.alert-refresh {
			margin-right: 4px;
		}
		.alert-close {
			margin-left: 4px;
		}
	}
}
</style>
